var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7083 5.62506C14.7833 2.60006 11.9666 0.858398 8.99996 0.858398C7.51663 0.858398 6.07496 1.29173 4.75829 2.10007C3.44163 2.91673 2.25829 4.1084 1.29163 5.62506C0.458293 6.9334 0.458293 9.0584 1.29163 10.3667C3.21663 13.4001 6.03329 15.1334 8.99996 15.1334C10.4833 15.1334 11.925 14.7001 13.2416 13.8917C14.5583 13.0751 15.7416 11.8834 16.7083 10.3667C17.5416 9.06673 17.5416 6.9334 16.7083 5.62506ZM8.99996 11.3667C7.13329 11.3667 5.63329 9.8584 5.63329 8.00007C5.63329 6.14173 7.13329 4.6334 8.99996 4.6334C10.8666 4.6334 12.3666 6.14173 12.3666 8.00007C12.3666 9.8584 10.8666 11.3667 8.99996 11.3667Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.46ae1e02c7f0343fb270fab704557423.svg";
export { ForwardRef as ReactComponent };